import React, { Component, Fragment } from 'react';
import { Field } from 'react-final-form';
import { Form } from 'antd';
import Translate from 'react-translate-component';

import { METRO_REQUEST_NEW } from 'constants/metro';
import { formItemLayout, wrapCellFormItem } from 'constants/formItemLayout';
import Text from 'components/common/form/Text';
import FileUploader from 'components/modals/events/result/forms/FileUploader';
import DocumentList from 'components/common/fields/DocumentList';

import RequestBaseFields from './RequestBaseFields';
import RequestPositionFields from './RequestPositionFields';

export default class PositionFields extends Component {
    onChangePosition = (value) => {
        if (!value) {
            this.props.getMetroPosition.dispatch(this.props.cellId ? ({
                id: this.props.cellId,
                city: this.props.city,
                routeType: this.props.routeType,
            }) : ({
                positionCode: this.props.positionCodeForCopy,
                city: this.props.city,
                routeType: this.props.routeType,
            }));
        }
    }

    render() {
        const { requestEditDisable, changePosition, approvalEdit, editPosition, showDocument, isApproval, isCNB, getChangeField } = this.props;
        const { routeType, requestType, requestId, positionCode, cellId, positionCodeForCopy, directorateEngl, storeCode, region } = this.props;
        const { pending } = this.props.getMetroPosition.meta;

        const disabled = requestEditDisable && !editPosition;
        const isNew = !isApproval && ((requestType === METRO_REQUEST_NEW) || changePosition);
        const positionDisabled = disabled || (
            !isApproval && (!!(positionCode || positionCodeForCopy) && !changePosition)
        );

        return <Fragment>
            { (isNew && !positionCodeForCopy) && (
                <Form.Item wrapperCol={wrapCellFormItem}>
                    <Translate content='metro.request.changePositionDescription' />
                </Form.Item>
            )}

            <RequestBaseFields
                disabled={disabled}
                editPosition={editPosition}
                positionDisabled={positionDisabled}
                getChangeField={getChangeField}
                approvalEdit={approvalEdit}
                routeType={routeType}
                isCNB={isCNB}
                filters={{
                    directorateEngl,
                    region,
                    storeCode,
                }}
            />

            <RequestPositionFields
                disabled={disabled}
                editPosition={editPosition}
                positionDisabled={positionDisabled}
                isNew={isNew}
                isApproval={isApproval}
                approvalEdit={approvalEdit}
                pending={pending}
                cellId={cellId}
                positionCodeForCopy={positionCodeForCopy}
                positionCode={positionCode}
                routeType={routeType}
                requestType={requestType}
                changePosition={changePosition}
                onChangePosition={this.onChangePosition}
            />

            { this.props.documents && (
                <Form.Item label={<Translate content='metro.request.documentAttached' />} {...formItemLayout}>
                    <DocumentList documents={this.props.documents} metro={Number(requestId)} />
                </Form.Item>
            )}

            { (!requestEditDisable || showDocument) && (
                <Form.Item label={<Translate content='metro.request.documentAttach' />} {...formItemLayout}>
                    <FileUploader
                        name='documentsUpload'
                        documentType='other'
                        multiple={true}
                    />
                </Form.Item>
            )}

            { this.props.saveDraftButton }

            { this.props.comments }
            { (!isApproval && !requestEditDisable) && (
                <Field
                    name='comment'
                    component={Text}
                    label={{ content: 'metro.request.comment' }}
                    showValidationErrors
                />
            )}
        </Fragment>;
    }
}
